export default "__VITE_ASSET__DVCRp6Ls__"